import { createFileRoute } from '@tanstack/react-router';
import { CreateSitePage } from '@/features/sites';

export const Route = createFileRoute('/projects/$projectId/sites/add')({
  component: CreateSitePageWrapper,
});

function CreateSitePageWrapper() {
  const { projectId } = Route.useParams();
  return <CreateSitePage searchParams={{ projectId: Number(projectId) }} />;
}
